import { hmApi } from 'store/api'

export const {
	useGetFrontendVersionQuery,
	useUpdateFrontendVersionMutation,
	useLazyUpdatedAppConfigQuery,
} = hmApi.injectEndpoints({
	endpoints: build => ({
		updatedAppConfig: build.query<undefined, void>({
			query: () => ({
				url: '/app-config',
				method: 'POST',
			}),
		}),

		getFrontendVersion: build.query<{ frontendVersion: string }, void>({
			query: () => ({
				url: '/app-config/version',
				method: 'GET',
			}),
		}),

		updateFrontendVersion: build.mutation<void, { version: string }>({
			query: body => ({
				url: '/app-config/version',
				method: 'PUT',
				body,
			}),
		}),
	}),
})
